import React, {Component} from "react";
import moment from 'moment';
import TransferTable from "../components/transferTable.js";
// import BootstrapTable from 'react-bootstrap-table-next';
// import paginationFactory from 'react-bootstrap-table2-paginator';

var config = require('../config.js');
const backend = config.backend;


class TransferHistory extends Component {

  _isMounted = false;

  /**
   * Initializes transfer history state for current staff.
   * @param {Object} props Component props.
   * @param {string|number} props.id Logged-in staff id.
   * @return {void}
   */
  constructor(props){
    super(props);
    this.state = {
      id : this.props.id,
      received_transfers: [],
      give_transfers: [],
      staffs:[],
      receive_check: false,
      give_check: false

    }
  }


  /**
   * Loads staff directory and transfer history on mount.
   * @param {void} _
   * @return {void}
   */
  componentDidMount() {
    this._isMounted = true;
    this.getTransfersHistory();
  }

  /**
   * Marks component as unmounted to avoid stale updates.
   * @param {void} _
   * @return {void}
   */
  componentWillUnmount() {
    this._isMounted = false;
  }


  /**
   * Renders sortable table header icon.
   * @param {Object} column Column metadata.
   * @param {number} index Column index.
   * @param {Object} controls Sort and filter controls.
   * @param {number} length Current row count.
   * @return {JSX.Element} Header with icon.
   */
  sortIcon (column, index, { sortElement, filterElement }, length){
    if (length <= 1){
      return (
        <div> {column.text} </div>
      )
    }
    else{
      var {icon} = <i className="material-icons">unfold_more</i>;

      var { order } = sortElement.props;
      if (order === 'desc'){
        icon = <i className="material-icons">keyboard_arrow_up</i>
      }
      else if (order === 'asc'){
        icon = <i className="material-icons">keyboard_arrow_down</i>
      }
      else{
        icon = <i className="material-icons">unfold_more</i>
      }

      return (
        <div>
          {icon} {column.text}
        </div>
      );
    }
  }

  /**
   * Compares date values for sorting transfer rows.
   * @param {string|Date} a First date.
   * @param {string|Date} b Second date.
   * @param {string} order Sort order.
   * @return {number} Comparator result.
   */
  sortDates (a, b, order) {
    var dateA = new Date(a), dateB = new Date(b);
    if (order === 'asc'){
      return dateA - dateB;
    }
    return dateB - dateA;
  }

// Get all staffs
  /**
   * Fetches all staff labels for transfer id mapping.
   * @param {void} _
   * @return {Promise<number>} Resolves when staff list is loaded.
   */
  getStaff(){
    var promise = new Promise((resolve, reject) => {
      fetch(backend + `api/allstaffsimple`, {
        method: 'GET',
        credentials: 'include'
      })
      .then(res => res.json())
      .then(({data}) => {
        if (this._isMounted){
          this.setState({staffs: data});
        }

        resolve (1);
      })
      .catch(function(err){
        console.error(err);
        reject (err);
      });
    });
    return promise;
  }

  // Get received_transfers
  /**
   * Fetches approved transfers received by current user.
   * @param {void} _
   * @return {Promise<Array>} Resolves with received transfer list.
   */
  getRecevied(){
    var promise = new Promise((resolve, reject) => {

      fetch(backend + `api/transfer/to/`+this.state.id, {
        method: 'GET',
        credentials: 'include'
      })
      .then(response => response.json())
      .then((response) => {
        // console.log('received transfers',response);
        var arr = [];
        const {staffs} = this.state;
        for (var key in response){

          if (response[key]['Status'] === "approve"){

            if(response[key]['Comment'] === 'null'){
              delete response[key]['Comment'];
            }

            for (var k in staffs) {
              if ( parseInt((response[key]['FromStaffId']).toString().trim(), 10) === (staffs[k]['value']) ){
              // if ( (typeof(response[key]['FromStaffId']) === "number" && response[key]['FromStaffId'] === staffs[k]['value']) || (typeof(response[key]['FromStaffId']) === "string" && parseInt((response[key]['FromStaffId']).toString().trim(), 10) === (staffs[k]['value']) ) ){

                response[key]['FromStaffId'] = staffs[k]['label'];

                // console.log(response[key]['FromStaffId'])

                arr.push(response[key]);
                break;

              }
            }
          }
        }

        if (this._isMounted){
          this.setState({received_transfers: arr, receive_check: true});
        }
        // console.log('received_transfers',arr);
        resolve (arr);
      })
      // .then( resolve (arr))
      .catch(err => console.error(err));
    });

    return promise;

  }


  // Get received_transfers
  /**
   * Fetches transfers given by current user.
   * @param {void} _
   * @return {Promise<Array>} Resolves with outgoing transfer list.
   */
  getGive(){
    var promise = new Promise((resolve, reject) => {

      fetch(backend + `api/transfer/from/`+this.state.id, {
        method: 'GET',
        credentials: 'include'
      })
      // fetch(`http://localhost:5000/api/transfer/to/`+this.state.id)
      .then(response => response.json())
      .then((response) => {
        // console.log('gave transfers',response)
        var arr = [];
        const {staffs} = this.state;
        for (var key in response){

            for (var k in staffs) {
              if (parseInt((response[key]['ToStaffId']).toString().trim(), 10) === (staffs[k]['value'])){
                response[key]['ToStaffId'] = staffs[k]['label'];

                arr.push(response[key]);
                break;

              }
            }

        }

        if (this._isMounted){
          this.setState({give_transfers: arr, give_check: true });
        }
        // console.log('received_transfers',arr);
        resolve (arr);
      })
      // .then( resolve (arr))
      .catch(err => console.error(err));
    });

    return promise;

  }




  /**
   * Orchestrates loading of staff list plus received/give histories.
   * @param {void} _
   * @return {void}
   */
  getTransfersHistory = _ => {

    this.getStaff()
    .then((res) => {
      this.getRecevied()
      .then((arr) => {

        this.getGive()
        .then((r) => {
        })
        .catch(err => console.error(err));

      })
      .catch(err => console.error(err));

    });



  }


  /**
   * Renders received transfer table section.
   * @param {Array} transfers Received transfer rows.
   * @return {JSX.Element} Received transfer table.
   */
  renderReceivedTable(transfers){

    // const {receive_check} = this.state;

    const columns = [{
      dataField: 'FromStaffId',
      text:'FROM',
      sort: true,
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      }
    }, {
      dataField: 'Amount',
      text:'AMOUNT (SGD)',
      sort: true,
      formatter: (amount) => {
        return '$ '+amount;
      },
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'StartDate',
      text:'FIRST TRANSFER DATE',
      sort: true,
      sortFunc: this.sortDates,
      formatter: (from) => {
        return moment(from).format('DD-MMM-YYYY');
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'Times',
      text:'MONTH(S)',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'EndDate',
      text:'LAST TRANSFER DATE',
      sort: true,
      sortFunc: this.sortDates,
      formatter: (end) => {
        return moment(end).format('DD-MMM-YYYY');
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);

      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'Status',
      text:'STATUS',
      sort: true,
      formatter: (status) => {
        // return status.charAt(0).toUpperCase() + status.substr(1);
        if (status === undefined || status === 'null' || status === null)
        {
          return status;
        }
        else if (status === 'approve')
        {
          return status.charAt(0).toUpperCase() + status.substr(1) + 'd';
        }
        else if (status === 'reject')
        {
          return status.charAt(0).toUpperCase() + status.substr(1) + 'ed';
        }
        else{
          return status.charAt(0).toUpperCase() + status.substr(1);
        }
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }];

    const defaultSorted = [{
      dataField: 'StartDate',
      order: 'desc'
    }];

    const options = {
      hidePageListOnlyOnePage: true,
      sizePerPage: 10,
      hideSizePerPage: true
    }

    return (
      <TransferTable transfers={transfers} pending={false} type="Staff" transferType="Received"/>
    )


    // return (<BootstrapTable bootstrap4 keyField='Id' data={ transfers } columns={ columns } bordered={ false } striped hover defaultSorted={ defaultSorted } pagination={ paginationFactory(options) }/>)



  }

  // renderGiveTable(data){
  /**
   * Renders outgoing transfer table section.
   * @param {Array} transfers Outgoing transfer rows.
   * @return {JSX.Element} Outgoing transfer table.
   */
  renderGiveTable(transfers){

    const columns = [{
      dataField: 'ToStaffId',
      text:'TO',
      sort: true,
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      }
    }, {
      dataField: 'Amount',
      text:'AMOUNT (SGD)',
      sort: true,
      formatter: (amount) => {
        return '$ '+amount;
      },
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'StartDate',
      text:'FIRST TRANSFER DATE',
      sort: true,
      sortFunc: this.sortDates,
      formatter: (from) => {
        return moment(from).format('DD-MMM-YYYY');
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'Times',
      text:'MONTH(S)',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'EndDate',
      text:'LAST TRANSFER DATE',
      sort: true,
      sortFunc: this.sortDates,
      formatter: (end) => {
        return moment(end).format('DD-MMM-YYYY');
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);

      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }, {
      dataField: 'Status',
      text:'STATUS',
      sort: true,
      formatter: (status) => {
        // return status.charAt(0).toUpperCase() + status.substr(1);
        if (status === undefined || status === 'null' || status === null)
        {
          return status;
        }
        else if (status === 'approve')
        {
          return status.charAt(0).toUpperCase() + status.substr(1) + 'd';
        }
        else if (status === 'reject')
        {
          return status.charAt(0).toUpperCase() + status.substr(1) + 'ed';
        }
        else{
          return status.charAt(0).toUpperCase() + status.substr(1);
        }
      },
      headerFormatter: (column, index, { sortElement, filterElement }) => {
        return this.sortIcon(column, index, { sortElement, filterElement }, transfers.length);
      },
      style:{
        // 'padding-left': '34px'
        'paddingLeft': '34px'
      }
    }];

    const defaultSorted = [{
      dataField: 'StartDate',
      order: 'desc'
    }];


    const options = {
      hidePageListOnlyOnePage: true,
      sizePerPage: 10,
      hideSizePerPage: true
    }

    return (
      <TransferTable transfers={transfers} pending={false} type="Staff" transferType="Give"/>);
      // <BootstrapTable bootstrap4 keyField='Id' data={ transfers } columns={ columns } bordered={ false } striped hover defaultSorted={ defaultSorted } pagination={ paginationFactory(options)  }/>  );



  }


  /**
   * Renders reusable empty state table message.
   * @param {void} _
   * @return {JSX.Element} Empty state element.
   */
  EmptyTable(){
    return  (<div className="only-row">No Transfer Found</div>);
  }

  /**
   * Renders reusable loading state table message.
   * @param {void} _
   * @return {JSX.Element} Loading state element.
   */
  LoadingTable(){
    return  (<div className="only-row">Loading...</div>);
  }

  /**
   * Renders transfer history page with received and give sections.
   * @param {void} _
   * @return {JSX.Element} Transfer history panel.
   */
  render() {
    const {received_transfers} = this.state;
    const {give_transfers} = this.state;
    const {give_check} = this.state;
    const {receive_check} = this.state;
    let received_table;
    let give_table;

    if(!receive_check){
      received_table = this.LoadingTable();
    }
    else{
      if (received_transfers.length === 0){
        received_table = this.EmptyTable();
      } else{
        received_table = this.renderReceivedTable(received_transfers);
      }
    }


    if(!give_check){
      give_table = this.LoadingTable();
    }
    else{
      if (give_transfers.length === 0){
        give_table = this.EmptyTable();
      } else{
        give_table = this.renderGiveTable(give_transfers);
      }
    }


    return (<div className ='transfer-display'>
      <div className='tab'><span>Transfer History</span></div>
      <div className = "table-container">
      <div><h3>Received</h3></div>

      {received_table}

      <div><h3>Give</h3></div>

      {give_table}

      </div>
    </div>);
  }
}

export default TransferHistory;
